import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { DateWiseSearch } from './DateWiseSearch'
export const UserWiseReport=() =>{
  
  return (
    <>
    <MainDiv>
    <DateWiseSearch />
   </MainDiv> 
    </>
    
  )
}
